import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tShopBldgModel } from '../models/tShopBldgModel';

@Injectable({
  providedIn: 'root'
})
export class tShopBldgService {

  constructor(private http: HttpClient) { }

  baseurl: string = AppSettings.BaseURI;

  readonly pathName = '/ShopBldg';

  getAllData(){
    return this.http.get<tShopBldgModel[]>(this.baseurl + this.pathName);
  }

  getDataById(id: string){
    return this.http.get<tShopBldgModel>(this.baseurl + this.pathName + '/' + id);
  }

  addData(data: tShopBldgModel){
    return this.http.post(this.baseurl + this.pathName, data);
  }

  deleteData(data: tShopBldgModel){
    return this.http.delete(this.baseurl + this.pathName + '/' + data.shopBldgID);
  }

  updateData(data: tShopBldgModel){
    return this.http.put(this.baseurl + this.pathName + '/' + data.shopID, data);
  }
}